import { connect } from 'react-redux';
import { reset } from 'redux-form';
import {
  setFormOfPaymentToCreditCard,
  setFormOfPaymentForAllItems,
  configurePaymentGateway,
  fetchAccountingTypesForCart,
  addCostCenterToCart,
  updateCartCostCenter,
  removeCostCenterFromCart,
  setFormOfPaymentToCash,
  setFormOfPaymentToWelltravelWallet,
  setFormOfPaymentToIATA,
  setFormOfPaymentToNone,
  fetchCartPeople,
  set3rdPartyPaymentMethod,
  fetchCart,
  resetFormOfPayment,
} from '../actions/common';
import Payment from '.';
import { NONE_FORM_OF_PAYMENT } from '../lib/helpers/fop_options';

const channelsWithQueuesAndRemarks = [
  'galileo',
  'apollo',
  'worldspan',
  'amadeus',
  'sabre',
  'lh_group',
  'american_airlines',
];

const mapStateToProps = (state, ownProps) => {
  const {
    cart,
    journeyElements,
    people,
    newCreditCard,
    costCenters,
    accountingTypes,
    staticProducts,
    paymentGateway,
    travelerCount,
    airports,
  } = state.common;

  const {
    id,
    currency,
    items,
    total,
    availableFormOfPayment,
    travelers,
    totalMargin,
    allocationPerAccountingType,
    costCenters: cartCostCenters,
  } = cart;

  const { laymanMode, cardDataAvailableByToken, exchange } = ownProps;
  const creditCards = { ...newCreditCard };
  const allCCTokens = Object.values(newCreditCard).map(creditCard => creditCard.token);
  const uniqueCCTokens = [...new Set(allCCTokens)];

  const availableFOPsForAll = exchange.canExchange
    ? Object.fromEntries(
        Object.entries(availableFormOfPayment).filter(([key]) => key !== NONE_FORM_OF_PAYMENT),
      )
    : availableFormOfPayment;

  Object.keys(creditCards).forEach(token => {
    if (cardDataAvailableByToken[token] !== true && creditCards[token].storedInCcv !== true) {
      delete creditCards[token];
    }
  });

  // The three ds authentication is mandatory-
  // when the booking happens in the travel app, or when there is an authentication-required item in the cart
  const threeDsAuthenticationMandatory =
    laymanMode || availableFOPsForAll.creditCard.requiredFields.threeDsAuthenticationRequired;

  return {
    availableFOPsForAll,
    allocationPerAccountingType,
    items,
    uniqueCCTokens,
    flightResultDetailsById: state.flights.resultDetailsById,
    journeyElements,
    itemsTotal: total,
    channelsWithQueuesAndRemarks,
    creditCards,
    paymentGateway,
    cartId: id,
    threeDsAuthenticationMandatory,
    travelers,
    travelerCount,
    costCenters,
    accountingTypes,
    cartCostCenters,
    currency,
    staticProducts,
    people,
    marginTotal: totalMargin,
    airports,
    flightServicesByResultId: state.flights.servicesByResultId,
    payableAmount: state.flights.currentExchangeQuote?.payableAmount,
    pastJourneyElement: journeyElements.flight[exchange.journeyElementId] || {},
  };
};

const mapDispatchToProps = dispatch => ({
  addCostCenterToCart: costCenter => dispatch(addCostCenterToCart(costCenter)),
  updateCartCostCenter: costCenter => dispatch(updateCartCostCenter(costCenter)),
  removeCostCenterFromCart: (costCenterId, accountingTypeId) =>
    dispatch(removeCostCenterFromCart(costCenterId, accountingTypeId)),
  setFormOfPaymentToCreditCard: (formData, itemId) =>
    dispatch(setFormOfPaymentToCreditCard(formData, itemId)),
  setFormOfPaymentToNone: itemId => dispatch(setFormOfPaymentToNone(itemId)),
  setFormOfPaymentToCash: itemId => dispatch(setFormOfPaymentToCash(itemId)),
  setFormOfPaymentToWelltravelWallet: itemId =>
    dispatch(setFormOfPaymentToWelltravelWallet(itemId)),
  setFormOfPaymentToIATA: itemId => dispatch(setFormOfPaymentToIATA(itemId)),
  setFormOfPaymentForAllItems: (formData, itemsWithFOP) =>
    dispatch(setFormOfPaymentForAllItems(formData, itemsWithFOP)),
  configurePaymentGateway: paymentGateway => dispatch(configurePaymentGateway(paymentGateway)),
  fetchCartPeople: () => dispatch(fetchCartPeople()),
  fetchAccountingTypesForCart: callbackParams =>
    dispatch(fetchAccountingTypesForCart(callbackParams)),
  set3rdPartyPaymentMethod: (method, callbackParams) =>
    dispatch(set3rdPartyPaymentMethod(method, callbackParams)),
  resetCreditCardBillingAddressForm: () => dispatch(reset('card-details')),
  fetchCart: (cartId, callbackParams) => dispatch(fetchCart(cartId, callbackParams)),
  resetFormOfPayment: () => dispatch(resetFormOfPayment()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
